import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportMenuComponent } from './components/report-menu/report-menu.component';
import { ReportingComponent } from './components/reporting/reporting.component';

const routes: Routes = [
    { path: '', component: ReportMenuComponent },
    { path: ':module', component: ReportMenuComponent },
    { path: ':urlSegment/:urlSegment', component: ReportingComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [],
})
export class ReportsRoutingModule {}
